export const VALUE_STATEMENTS = Object.freeze({
  TRAVELING: {
    statementId: 0,
    statementText: 'Traveling often',
    displayOrdinal: 16,
  },
  MAKING_A_MEANINGFUL_IMPACT: {
    statementId: 1,
    statementText: 'Making an impact',
    displayOrdinal: 14,
  },
  MAINTAINING_AN_EMERGENCY_FUND: {
    statementId: 2,
    statementText: 'A low-stress lifestyle',
    displayOrdinal: 7,
  },
  MANAGING_DEBT: {
    statementId: 3,
    statementText: 'Living debt free',
    displayOrdinal: 4,
  },
  PURSUING_A_PASSION: {
    statementId: 4,
    statementText: 'Community building',
    displayOrdinal: 13,
  },
  LEAVING_AN_INHERITANCE: {
    statementId: 5,
    statementText: 'Starting/growing a family',
    displayOrdinal: 12,
  },
  LIVING_IN_MY_IDEAL_HOME: {
    statementId: 6,
    statementText: 'Living in my ideal home',
    displayOrdinal: 9,
  },
  MAINTAINING_A_HEALTHY_LIFESTYLE: {
    statementId: 7,
    statementText: 'A healthy lifestyle',
    displayOrdinal: 6,
  },
  MAKING_MAJOR_PURCHASES: {
    statementId: 8,
    statementText: 'Being financially wealthy',
    displayOrdinal: 3,
  },
  PAYING_FOR_EDUCATION: {
    statementId: 9,
    statementText: 'Supporting loved ones',
    displayOrdinal: 10,
  },
  SPENDING_TIME_WITH_FRIENDS_AND_FAMILY: {
    statementId: 10,
    statementText: 'Time with friends and family',
    displayOrdinal: 11,
  },
  SAVING_FOR_RETIREMENT: {
    statementId: 11,
    statementText: 'Retiring early',
    displayOrdinal: 2,
  },
  PLANNING_FOR_HEALTH_CARE_COSTS: {
    statementId: 12,
    statementText: 'A focus on spirituality',
    displayOrdinal: 15,
  },
  RUNNING_A_BUSINESS: {
    statementId: 13,
    statementText: 'Being my own boss',
    displayOrdinal: 5,
  },
  PROTECTING_YOUR_GOALS: {
    statementId: 14,
    statementText: 'Frequent fun/adventure',
    displayOrdinal: 8,
  },
  ADD_YOUR_OWN_PRIORITY: {
    statementId: 15,
    statementText: 'Add your own priority',
    displayOrdinal: 1,
  },
});

export const valueStatementMapFP = new Map([
  [VALUE_STATEMENTS.TRAVELING.statementId, VALUE_STATEMENTS.TRAVELING],
  [
    VALUE_STATEMENTS.MAKING_A_MEANINGFUL_IMPACT.statementId,
    VALUE_STATEMENTS.MAKING_A_MEANINGFUL_IMPACT,
  ],
  [
    VALUE_STATEMENTS.MAINTAINING_AN_EMERGENCY_FUND.statementId,
    VALUE_STATEMENTS.MAINTAINING_AN_EMERGENCY_FUND,
  ],
  [VALUE_STATEMENTS.MANAGING_DEBT.statementId, VALUE_STATEMENTS.MANAGING_DEBT],
  [
    VALUE_STATEMENTS.PURSUING_A_PASSION.statementId,
    VALUE_STATEMENTS.PURSUING_A_PASSION,
  ],
  [
    VALUE_STATEMENTS.LEAVING_AN_INHERITANCE.statementId,
    VALUE_STATEMENTS.LEAVING_AN_INHERITANCE,
  ],
  [
    VALUE_STATEMENTS.LIVING_IN_MY_IDEAL_HOME.statementId,
    VALUE_STATEMENTS.LIVING_IN_MY_IDEAL_HOME,
  ],
  [
    VALUE_STATEMENTS.MAINTAINING_A_HEALTHY_LIFESTYLE.statementId,
    VALUE_STATEMENTS.MAINTAINING_A_HEALTHY_LIFESTYLE,
  ],
  [
    VALUE_STATEMENTS.MAKING_MAJOR_PURCHASES.statementId,
    VALUE_STATEMENTS.MAKING_MAJOR_PURCHASES,
  ],
  [
    VALUE_STATEMENTS.PAYING_FOR_EDUCATION.statementId,
    VALUE_STATEMENTS.PAYING_FOR_EDUCATION,
  ],
  [
    VALUE_STATEMENTS.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY.statementId,
    VALUE_STATEMENTS.SPENDING_TIME_WITH_FRIENDS_AND_FAMILY,
  ],
  [
    VALUE_STATEMENTS.SAVING_FOR_RETIREMENT.statementId,
    VALUE_STATEMENTS.SAVING_FOR_RETIREMENT,
  ],
  [
    VALUE_STATEMENTS.PLANNING_FOR_HEALTH_CARE_COSTS.statementId,
    VALUE_STATEMENTS.PLANNING_FOR_HEALTH_CARE_COSTS,
  ],
  [
    VALUE_STATEMENTS.RUNNING_A_BUSINESS.statementId,
    VALUE_STATEMENTS.RUNNING_A_BUSINESS,
  ],
  [
    VALUE_STATEMENTS.PROTECTING_YOUR_GOALS.statementId,
    VALUE_STATEMENTS.PROTECTING_YOUR_GOALS,
  ],
  [
    VALUE_STATEMENTS.ADD_YOUR_OWN_PRIORITY.statementId,
    VALUE_STATEMENTS.ADD_YOUR_OWN_PRIORITY,
  ],
]);
